// @flow
export default (theme: Object): Object => ({
    form: {
        minWidth: 260,
        maxWidth: 350,
        width: '70vw',
        padding: theme.spacing(3, 0, 5, 0),
    },
    label: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    invitedGroups: {
        marginBottom: theme.spacing(2),
    },
    group: {
        width: '100%',
        '&:not(:last-child)': {
            marginBottom: theme.spacing(1),
        },
    },
    select: {
        marginBottom: 40,
    },
    selectInput: {
        '@global input': {
            marginLeft: 36,
            textAlign: 'center',
        },
    },
    selectPlaceholder: {
        left: 0,
        textAlign: 'center',
        width: '100%',
    },
    chipRoot: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        background: 'white',
        height: '60px',
        border: [['1px', 'solid', theme.palette.grey[100]]],
        borderRadius: '30px',
        boxShadow: theme.shadows[1],
    },
    chipAvatar: {
        position: 'absolute',
        left: 0,
        background: 'transparent',
        color: theme.palette.common.black,
        height: 60,
        width: 60,
        fontSize: 24,
        paddingLeft: 24,
        justifyContent: 'flex-start',
    },
    chipLabel: {
        fontSize: 18,
    },
    chipDeleteIcon: {
        position: 'absolute',
        right: 0,
    },
    invitedCount: {
        position: 'absolute',
        width: '100%',
        left: 0,
        bottom: theme.spacing(1),
    },
});
